// src/utils/authHelpers.js

import { ROLES } from "./roles";

// Le SUPER_ADMIN gère la plateforme (toutes les écoles) : ses routes ne
// sont PAS préfixées par un slug d'établissement.
// Tous les autres rôles appartiennent à UN établissement précis : leurs
// routes sont préfixées par /:slug/... pour rester cohérent avec le
// backend (JWT + réponse de login contiennent etablissement_slug).
export const getDashboardRoute = (role, etablissementSlug) => {
  switch (role) {
    case ROLES.SUPER_ADMIN:
      return "/super-admin/dashboard";

    case ROLES.ADMINISTRATEUR:
      return `/${etablissementSlug}/admin/accueil`;

    case ROLES.ENSEIGNANT:
      return `/${etablissementSlug}/enseignant/accueil`;

    case ROLES.PARENT:
      return `/${etablissementSlug}/parent/accueil`;

    default:
      return "/login";
  }
};
